<template>
    <div>
    
        <div class="grid-container">
            <div class="top-half"></div>
            <div class="bottom-half">
                <div class="card-container">
                    <CCard class="border-radius-16px p-4 mb-5">
                        <div class="text-center">
                            <h3 class="custom-40px-700 text-center font-color-064BB4"><img src="../assets/img/status-up-blue.png" style="max-width:48px" class="mr-2" />MyHR Solutions</h3>
                            <div class="text-left">
                                <img src="../assets/img/arrowback.png" style="max-width:20px" class="text-left" @click="GoBack()" />
                                <h4 class="custom-36px-700 font-color-171717 text-left mt-5">Register Account</h4>
                                <p class="custom-16px-400 text-left">Let’s create your account</p>
                            </div>
    
                        </div>
    
                        <div v-if="Error" class="ml-4 mr-4 mt-4">
                            <CAlert show color="danger">
                                <strong class="text-danger mr-2">Error !</strong> {{ Message }}
                            </CAlert>
                        </div>
                        <div class="mt-3">
                            <CCol sm="12">
                            <form>
                            <CRow>
                                <CCol sm="12">
                                    <strong class="text-left">Name</strong>
                                    <CInput type="text" class="" v-model="name" />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="12">
                                    <strong class="text-left">Email</strong>
                                    <CInput type="text" class="" v-model="userEmail" />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="12">
                                    <strong class="text-left">Country</strong>
                                    <v-select v-model="selectedCountry" :options="countryOptions" label="CountryName" @input="onCountrySelect"></v-select>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="12 mt-3">
                                    <strong class="text-left mt-3">Phone Number</strong>
                                    <strong class="phone-input">
                                        <CInput v-model="selectedCountryCode" :options="countryCodeOptions" :disabled="true" class="country-code-select"/>
                                        <CInput type="text" v-model="phone" placeholder="Enter your phone number" class="phone-number-input"/>
                                    </strong>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="12 mt-3">
                                    <strong class="text-left">Password</strong>
                                    <CInput type="password" class="" v-model="userPassword" @input="password_check"/>
                                </CCol>
                            </CRow>
                            <!-- <strong class="text-left">User Type</strong>
                            <v-select v-model="selectedRole" :options="roleOptions" label="Name"></v-select> -->
                            <br />
                            <input type="radio" class="mr-2" />By creating your account, you agree to our <strong> Terms and Conditions</strong> & <strong>Privacy Policy</strong>
                            </form>
                        </CCol>
                    </div>

                        <p class="frmValidation mt-3" :class="{'frmValidation--passed' : userPassword.length > 7}">
                                            <img v-if="userPassword.length > 7" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" alt="Unchecked" class="frmIcon" style="width:20px" /> A minimum of 8 character
    
                                        </p>
                                        <p class="frmValidation" :class="{'frmValidation--passed' :has_uppercase }">
                                            <img v-if="has_uppercase" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" />  At least one uppercase character
                </p>

                                        <p class="frmValidation" :class="{'frmValidation--passed' : has_lowercase }">
                                            <img v-if="has_lowercase" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one lowercase character
                                        </p>
                                        <p class="frmValidation" :class="{'frmValidation--passed' : has_number }">
                                            <img v-if="has_number" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one numeric character
                                        </p>
                                        <p class="frmValidation" :class="{'frmValidation--passed' : has_special }">
                                            <img v-if="has_special" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one symbol character
                                        </p>
                        <div class="text-center mt-3 mb-4">
                            <CButton class="bg-0B63F6 p-2 text-center text-white pr-5 pl-5 border-radius-half" v-if="userPassword.length > 7 && has_uppercase && has_lowercase && has_number && has_special" @click="registerAccount" block>Create</CButton>
                            <CButton class="bg-636f83 p-2 text-center text-white pr-5 pl-5 border-radius-half" v-else block style="cursor:not-allowed">Create</CButton>
                        </div>
                        <p>Already have an account? <a href="">Login</a></p>
    
                    </CCard>
                </div>
            </div>
        </div>
    
    
    
    </div>
</template>


<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

Vue.use(VuejsDialog);
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,

            name: "",
            phone: "",
            userPassword: "",
            userEmail: "",
            selectedRole: "",
            selectedCountry: "",

            Error: false,

            has_number: false,
            has_lowercase: false,
            has_uppercase: false,
            has_special: false,
           

            roleOptions: [],
            countryOptions: [],
            selectedCountryCode: '',
            phone: '',
            countryCodeOptions: [],
        };
    },
    async mounted() {
    {
        await this.getUserType();
        await this.GetCountry();

    }
},


    methods: {
        
        GoBack() {
            this.$router.push("/");
        },
        registerAccount() {
            this.lblProgress = "Processing";

            const formData = new FormData();

            if (this.userEmail === "" || this.userPassword === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("name", this.name);
                formData.append("email", this.userEmail);
                formData.append("countryId", this.selectedCountry.Id);
                formData.append("phone", this.phone);
                formData.append("password", this.userPassword);

                this.$API
                    .post(this.$Register, formData)
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;

                        }
                        if (response.status == 200) {

                            if (response.data.status !== 400) {
                                if (response.data.status !== 400) {

                                    if (
                                        this.$route.query.targetUrl != "" &&
                                        (this.$route.query.targetUrl != null) &
                                        (this.$route.query.targetUrl != undefined)
                                    ) {
                                        this.$router.push(this.$route.query.targetUrl);
                                    } else {
                                        this.$dialog
                  .alert(
                    "You have successfully register the email was sent to" +
                    "\n" +
                    this.userEmail)
                  .then(function () {});
                                        this.$router.push("Login");
                                    }
                                } else {
                                    this.Loading = false;
                                    this.Message = response.data.message;
                                    this.Error = true;
                                    this.MessageError = true;
                                }

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                                this.MessageError = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                            this.MessageError = true;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                        this.MessageError = true;
                    });
            }
        },

        password_check() {
            this.has_number = /\d/.test(this.userPassword);
            this.has_lowercase = /[a-z]/.test(this.userPassword);
            this.has_uppercase = /[A-Z]/.test(this.userPassword);
            this.has_special = /[!@#$%^&*(),.?":{}|<>]/.test(this.userPassword);

            // Debugging logs
            console.log('Password:', this.userPassword);
            console.log('Has number:', this.has_number);
            console.log('Has lowercase:', this.has_lowercase);
            console.log('Has uppercase:', this.has_uppercase);
            console.log('Has special:', this.has_special);
        },
        async getUserType() {
              try {
                  const response = await this.$API.get(this.$GetUserType);
                  if (response.status === 200) {
                      this.roleOptions = response.data;
                  } else {
                      // Handle non-200 status code
                      console.error("Failed to fetch user information:", response);
                  }
              } catch (error) {
                  console.error("Error fetching user information:", error);
                  // Handle the error here
              }
          },

          async GetCountry() {
            try {
                const response = await this.$API.get(this.$GetCountry);
                if (response.status === 200) {
                this.countryOptions = response.data;
                this.countryCodeOptions = response.data.map(country => ({
                    label: `+${country.CountryCallingCode}`,
                    value: country.CountryCallingCode,
                }));
                } else {
                console.error("Failed to fetch country information:", response);
                }
            } catch (error) {
                console.error("Error fetching country information:", error);
            }
            },
            onCountrySelect(selected) {
            this.selectedCountryCode = selected.CountryCallingCode; // Assuming your country data includes a CountryCallingCode field
            },



    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.phone-input {
  display: flex;
  align-items: center;
}
.country-code-select {
  width: 100px;
  margin-right: 10px;
}
.phone-number-input {
  flex: 1;
}
</style>